// relocate ZenDesk meatball to avoid mobile toolbar
window.zESettings = {
  webWidget: {
    offset: {
      mobile: {
        vertical: "65px",
      },
    },
  },
};
